/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2022 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by kyang on 8/4/22.
 */

function FileProgressServiceConstructor(
    this: JS5Object,
    _: JS5Object,
    $timeout: JS5Function,
    Rx: JS5Object,
    ModalService: JS5Object,
    NotificationService: JS5Object,
) {
    let currentUploads: JS5Object[] = [];
    let allUploads: JS5Object[] = [];
    let uploadNotification: JS5Object = null;

    enum UploadStatus {
        PENDING = 'PENDING',
        SUCCEEDED = 'SUCCEEDED',
        FAILED = 'FAILED',
        CANCELLED = 'CANCELLED',
    };
    this.UploadStatus = UploadStatus;

    this.getPendingUploads = () => {
        return currentUploads.filter((uploadInfo: JS5Object) => {
            return (uploadInfo.status === UploadStatus.PENDING);
        });
    };

    // Includes previous batches & current batch
    this.getAllUploads = () => {
        return allUploads;
    };

    this.addPendingUpload = (filename: string, targetPackageId: string, extraProps?: JS5Object) => {
        let uploadInfo = {
            status: UploadStatus.PENDING,
            filename: filename,
            targetPackageId: targetPackageId,
            dateStarted: new Date(),
            progressObservable: new Rx.BehaviorSubject(0),
            extraProps: extraProps
        };
        currentUploads.push(uploadInfo);
        allUploads.push(uploadInfo);
        if (!uploadNotification) {
            uploadNotification = NotificationService.createPersistentWarningNotification(
                'FILE UPLOAD IN PROGRESS',
                'Uploading files... DO NOT refresh or close the page.',
                () => { ModalService.showFileProgressModal(); },
                false
            );
        }
        return uploadInfo;
    }

    const endUpload = (uploadInfo: JS5Object) => {
        let anyUploadPending = false;
        let anyUploadFailed = false;
        for (const uploadInfo of currentUploads) {
            anyUploadPending = anyUploadPending || uploadInfo.status === UploadStatus.PENDING;
            anyUploadFailed = anyUploadFailed || uploadInfo.status === UploadStatus.FAILED;
        }
        uploadInfo.progressObservable.onCompleted();
        if (!anyUploadPending) {
            const closingNotification = uploadNotification;
            currentUploads = [];
            uploadNotification = null;
            if (anyUploadFailed) {
                NotificationService.createFailureNotification(
                    'Some files failed to upload.',
                    {
                        delay: -1,
                        moreInfoClickHandler: () => { ModalService.showFileProgressModal(); }
                    });
            } else {
                NotificationService.createPersistentSuccessNotification(
                    'UPLOAD COMPLETED',
                    'It is now SAFE to refresh or close this page.',
                    () => { ModalService.showFileProgressModal() },
                    true
                );
            }
            // Notice: When $timeout resolves, uploadNotification != closingNotification
            $timeout(() => closingNotification.close());
        }
    };

    this.completeUpload = (uploadInfo: JS5Object) => {
        uploadInfo.status = UploadStatus.SUCCEEDED;
        uploadInfo.progressObservable.onNext(1);
        endUpload(uploadInfo);
    }

    this.cancelUpload = (uploadInfo: JS5Object) => {
        uploadInfo.status = UploadStatus.CANCELLED;
        endUpload(uploadInfo);
    }

    this.failUpload = (uploadInfo: JS5Object, error: any) => {
        uploadInfo.status = UploadStatus.FAILED;
        endUpload(uploadInfo);
    }

    this.clearCompletedUploads = () => {
        _.remove(currentUploads, (uploadInfo: JS5Object) => uploadInfo.status !== UploadStatus.PENDING);
        _.remove(allUploads, (uploadInfo: JS5Object) => uploadInfo.status !== UploadStatus.PENDING);
    };
}

angular
    .module('prism-ui.system')
    .service('FileProgressService', FileProgressServiceConstructor);
